import { render, staticRenderFns } from "./BandTravellerTemplate.vue?vue&type=template&id=5d4c30d0"
import script from "./BandTravellerTemplate.vue?vue&type=script&lang=js"
export * from "./BandTravellerTemplate.vue?vue&type=script&lang=js"
import style0 from "./BandTravellerTemplate.vue?vue&type=style&index=0&id=5d4c30d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports